import React, { Component } from "react";
import { connect } from 'react-redux';
import { setLogin, setVerify } from '../_actions/user';
import 'react-notifications/lib/notifications.css';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { TextField, Button } from "@material-ui/core";
import axios from 'axios';
import {API} from '../_redux/helper'
import ReactGA from 'react-ga';
import {GAevent} from './TrackingEvent'
import ReactPixel from 'react-facebook-pixel';
import CryptoJS from 'crypto-js';
import Loading from '../components/Loading'
var message = '';




class Login extends Component {
  // For Login
  constructor() {
    super();
    this.state ={
      fields: {
          email: "",
          password: "",
          message: "",
          emailconfirmed: "",
          kuesionerconfirmed: "",
          token: "",
      },
      register: false,
      errors: {},
      show:false,
      disabled : false,
      status:true,
      visible:false,
      status_password:true
  }
} 

componentDidMount(){
  ReactGA.pageview(window.location.pathname + window.location.search);
}


handleValidation(){
  let fields = this.state.fields;
  let errors = {};
  let formIsValid = true;
  if(!fields["email"]){
     formIsValid = false;
     errors["email"] = "Email cannot be empty";
  }

  if(typeof fields["email"] !== "undefined" && !fields["email"] === false){
     let lastAtPos = fields["email"].lastIndexOf('@');
     let lastDotPos = fields["email"].lastIndexOf('.');

     if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errors["email"] = "Email is not valid";
      }}

  if(!fields["password"]){
      formIsValid = false;
      errors["password"] = " Password cannot be empty";
  }
  
  const pattern = /["'`]/g;
  if(fields["password"].match(pattern)) {
    formIsValid = false;
    errors["password"] = "Password contains forbidden characters"
  }

  if(fields["email"].match(pattern)) {
    formIsValid = false;
    errors["email"] = "Email contains forbidden characters"
  }

  this.setState({errors: errors});
  return formIsValid;
  }

  postEmail = (e) => {
    e.preventDefault();
    const dataEmail = {
      email: this.state.fields["email"],
    };
    this.props.setVerify1(dataEmail);
    const salah = this.createNotification('notif2');
    salah()
    GAevent(`Send Email to Verify - ${window.location.pathname}`,"Send Email to Verify")
    ReactPixel.track(`Send Email to Verify - ${window.location.pathname}`,"Send Email to Verify")
  };

  
  handleChange(field, e){
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
    
  }

  onChangeEmail = event => {
    this.setState({ email: event.target.value });
  };
  
  onChangePassword = event => {
    this.setState({ password: event.target.value });
  };


  login = (e) => {
    e.preventDefault();
    if(this.handleValidation()){
      let user = {
        email: this.state.fields["email"],
        password: this.state.fields["password"]
      };
      let key = CryptoJS.enc.Utf8.parse("68D83A2CCC84F2A8B7ADB64B38B86576");
      let iv = CryptoJS.enc.Utf8.parse("116C893F5CF1AA0AFAABBF28C32CFBE2");
      user["email"] = CryptoJS.TripleDES.encrypt(user.email, key, { iv: iv, mode: CryptoJS.mode.CBC }).toString();
      user["password"] = CryptoJS.TripleDES.encrypt(user.password, key, { iv: iv, mode: CryptoJS.mode.CBC }).toString();
         
      const salah = this.createNotification('error');
      const peringatan = this.createNotification('warning');
      const cobaSuccess = this.createNotification('success');
      const stopLogin = this.createNotification('stop');
      var now = new Date().getTime();
      var setupTime = sessionStorage.getItem('setupTime');
      this.setState({visible:true})
      axios
        .post(`${API}/api/login`,user)
        .then(res => {
            if (res.data.is_tooltip==="" ||res.data.is_tooltip===null ||res.data.is_tooltip==="null" ||res.data.is_tooltip===undefined){
              sessionStorage.setItem("sidebar",false)
              sessionStorage.setItem('tooltip', 1)
            }else{
              sessionStorage.setItem("sidebar",false)
            }
            
            if (res.data.emailconfirmed===true)  {
              localStorage.setItem("token", res.data.token);
              sessionStorage.setItem("token", res.data.token);
              sessionStorage.setItem("email", res.data.email);
              localStorage.setItem("email", res.data.email);
              sessionStorage.setItem('setupTime', now)
              localStorage.setItem("setupTime", now);
              sessionStorage.setItem('kuesionerconfirmed', res.data.kuesionerconfirmed)
              localStorage.setItem('kuesionerconfirmed', res.data.kuesionerconfirmed)
              sessionStorage.setItem("rating-values",false)
              sessionStorage.setItem("rating-interest",false)
              sessionStorage.setItem("rating-vip",false)
              sessionStorage.setItem("rating-personality",false)
              sessionStorage.setItem("rating-program",false)
                cobaSuccess()
                if(window.location.search && window.location.search.indexOf('refer_code') === -1) {
                  window.location.href = "/Welcome-to-KaryaTalents"
                } else if(res.data.is_new_journey===null || res.data.is_new_journey==="" || res.data.is_new_journey===0 || res.data.is_new_journey==="null" ){
                  window.location.href = "/Welcome-to-KaryaTalents"
                }else if (res.data.is_new_journey===true || res.data.is_new_journey==="true"){
                  // window.location.href = "/NewDashboard";
                  let list_ref = ["/referral", "/work_assessment", "/myprofile", "/newdashboard", "/digitallearningplatform", "/careercenter","/jobopportunities"]
                  // let list_ref = ["/referral"]
                  setTimeout(() => {
                  
                 
                  if (sessionStorage.getItem("ref")!==null ){
                    if (list_ref.indexOf(sessionStorage.getItem("ref").toLowerCase()) !== -1 ){
                      window.location.href = sessionStorage.getItem("ref");
                    }else{
                      window.location.href = "/NewDashboard";
                    }
                  }else{
                    window.location.href = "/NewDashboard";
                  }
                  
                }, 200);

                }
              
            }
            else if ((res.data.emailconfirmed===false) || (res.data.kuesionerconfirmed===false)) {
              window.location.href = "#";
              peringatan()
            }

            //set timeOut for sessionStorage
          if (setupTime === null) {
              sessionStorage.setItem('setupTime', now)
          } else {
            if(now-setupTime > 1000000) {
              sessionStorage.clear()
              window.location.href="/"
          }
          }

            this.setState({visible:false})

        })
        .catch(err => {
          if (err.response.status === 401) {
            salah()
          } else if (err.response.status === 403) {
            message = err.response.data.message
            stopLogin()
          }
        })
    }
    GAevent(`Login - ${window.location.pathname}`,'Submit (Login)') 
    ReactPixel.track(`Login - ${window.location.pathname}`,'Submit (Login)'); 
  };




  createNotification = (type) => {
    return () => {
      switch (type) {
        case 'info':
          NotificationManager.info('Please verify your email address', 'Email Verification', 9000, () => {
            alert('callback');
          });
          break;
        case 'success':
          NotificationManager.success('Login Success','Congratulation');
          break;
          case 'notif2':
            NotificationManager.success('Please check your email for verification','Success!',10000);
            break;
        case 'warning':
          NotificationManager.warning(  <form onSubmit={this.postEmail} className="formVerify"><button className="btnVerify" type="submit">Resend email</button></form>,
          <div className="flex verify width-100 column"><p className="bold">Email Verification</p><p className="normal">Please verify your email
          address</p></div>, 30000);
          break;
        case 'error':
          NotificationManager.error('Incorrect email address and / or password', 'Ups.. Sorry' , 5000);
          break;
        case 'stop':
          NotificationManager.error(message, 'Stop!', 5000);
          break;
      }
    };
  };

  showPassword=(e)=>{
    this.setState({show:!this.state.show})
  }



  render() {
    const {show, status, status_password}= this.state



    return (        
      <div className="login">
        <form  id="login">
            <div className="ey-1">
              <h4>
              Login
              </h4>
              <p>Welcome back!</p>
              <div className="box-sign ">
                <TextField  label="Email" variant="outlined" type="email" className="form-control" onFocus={(e)=>this.setState({status:false})}
                  name="email" id="email" refs="email" aria-describedby="emailHelp" onChange={this.handleChange.bind(this, "email")} 
                  value={this.state.fields["email"]} style={{paddingTop:"3px "}}/>
                <span className="err-ntf" style={{color: "red", fontSize:"12px"}}>{this.state.errors["email"]}</span>
              </div>
              <div className={"box-sign tC show-pass"}>
                <TextField  label="Password" variant="outlined" className="form-control" type={show?"text":"password"} name="password" id="password" 
                  refs="password" onChange={this.handleChange.bind(this, "password")} value={this.state.fields["password"]}  
                  onFocus={(e)=>this.setState({status_password:false})}/>
                  {show===true &&
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(false)}>
                   <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                   </svg>}
                  {show===false &&
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(true)}>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                  <line x1="19.7231" y1="4.29703" x2="3.96037" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  }

                <span className="err-ntf" style={{color: "red", fontSize:"12px"}}>{this.state.errors["password"]}</span>
              </div>
              <div>
                <Button id="button" type="submit" variant="outlined" name="login-button" className="_reg" onClick={this.login}
                  style={{ marginTop: "9px", backgroundColor: "#3B6C98", width: "100%", color: "white" }}>
                  Login
                </Button>
              </div>
            </div>
          </form>
          <NotificationContainer/>
        </div>
        
    );
  }
}


const mapStateToProps = state => {
  return {
    user: state.login,
    dataEmail : state.verifyRed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login1: user => {
      dispatch(setLogin(user));
    },
    setVerify1: (event) => {
      dispatch(setVerify(event));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Login);
